export interface Follow {
  id: string;
  followerId: string;
  creatorId: string;
  createdAt: Date;
}
